<script>
  //// imports
  import { formatTimeDelta } from "lib/util/formatfunctions.js";
  // data
  let categories = [
    // "appIcon",
    // "appName",
    // "appShare",
    // "selected",
    "time",
    "mouseclicks",
    "keystrokes",
    "clickratio",
    // "copy",
    // "paste",
    // "category",
  ];

  export let appData = [];
  export let loading = false;
  export let currentApp;
  export let summary = false;

  // Function to calculate sums
  let currentAppData = {
    time: 0,
    mouse: 0,
    keyboard: 0,
    copy: 0,
    paste: 0,
    category: 0,
    appIcon: "",
    appName: "",
    appShare: 0,
    normalizedShare: 0,
    share: 0,
  };

  let summaryItem = {};

  $: if (summary) getSummary(appData);

  $: {
    if (currentApp !== "") {
      const app = appData.find(
        (app) => app.id == currentApp || app?.windowtitle == currentApp
      );
      if (app) {
        currentAppData = app;
      }
    } else if (summary) {
      currentAppData = summaryItem;
    }
  }
  function getSummary(appData) {
    summaryItem = {
      id: 0,
      time: calculateSum("time"),
      mouseclicks: calculateSum("mouseclicks"),
      keystrokes: calculateSum("keystrokes"),
      appName: "Total Summary",
    };
  }

  function calculateSum(property) {
    return appData.reduce((acc, curr) => acc + curr[property], 0);
  }

  // Function to calculate share (rounded to whole numbers)

  function calculateShareSum(property) {
    const sum = calculateSum(property);
    return property === "time"
      ? sum
      : Math.round((sum / calculateSum("appShare")) * 100);
  }

  // Function to calculate the percentage share of interactions (keyboard, mouse, copy, paste)

  function calculateInteractionShare(property) {
    const interactionSum =
      calculateSum("keyboard") +
      calculateSum("mouse") +
      calculateSum("copy") +
      calculateSum("paste");
    const sum = calculateSum(property);
    return Math.round((sum / interactionSum) * 100);
  }
</script>

<div class="info_wrapper">
  {#each categories as key}
    {#if key !== "appIcon" && key !== "appName" && key !== "appShare" && key !== "selected" && (key !== "normalizedShare") & (key !== "category")}
      <div class="info">
        <div class="type">
          <div class="type_icon">
            <img src={`/img/assistant/icons/${key}_dark.svg`} alt="" />
          </div>
          <div class="type_value">
            {key.charAt(0).toUpperCase() + key.slice(1)}
          </div>
        </div>
        <div class="value">
          {#if loading}
            <div class="value">...</div>
          {:else if key === "time"}
            <div class="value bold">
              {currentAppData[key] ? formatTimeDelta(currentAppData[key]) : ""}
            </div>
          {:else if key === "clickratio"}
            <div class="value">
              {currentAppData["mouseclicks"]
                ? (
                    currentAppData["mouseclicks"] / currentAppData["keystrokes"]
                  ).toFixed(2)
                : ""}
            </div>
          {:else}
            <div class="value">{currentAppData[key] ?? ""}</div>
            <!-- <div>-</div> -->
            <!-- <div class="share bold">
              {key === "keyboard" ||
              key === "mouse" ||
              key === "copy" ||
              key === "paste"
                ? calculateInteractionShare(key)
                : calculateShareSum(key)}%
            </div> -->
          {/if}
        </div>
      </div>
    {/if}
  {/each}
</div>

<style>
  .info {
    height: 3rem;
    display: flex;
    justify-content: space-between;
    border-radius: 0.5rem;
    background-color: var(--pax-smoke);
    align-items: center;
    padding: 0 1rem;
  }

  .info_wrapper {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  .type,
  .value {
    display: flex;
    gap: 0.5rem;
    align-items: center;
  }

  .type_icon {
    width: 1.5rem;
  }
</style>
